<template>
  <div class="titleTop">
    <h4>{{titleName}}</h4>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {};
  },
  props: ["titleName"],
  methods: {},
  watch: {}
};
</script>

<style lang="scss" scoped>
.titleTop {
  > h4 {
    font-size: px2rem(30);
    color: #0245bf;
    height: px2rem(93);
    line-height: px2ren(93);
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>